import LoadingSpinner from "@client/components/utils/LoadingSpinner";
import { RouteErrorBoundary } from "@client/components/utils/RouteErrorBoundary";
import { type ReactNode, Suspense } from "react";

/**
 * Wraps an app's routes so a page that crashes or is still loading its lazy
 * chunk takes over only the page area, leaving the app bar usable. The error
 * boundary sits outside the Suspense so a failed chunk load is caught too.
 */
export function RouteBoundary({
  homeHref,
  homeLabel,
  fallback = <LoadingSpinner />,
  children,
}: {
  homeHref: string;
  homeLabel: string;
  fallback?: ReactNode;
  children: ReactNode;
}) {
  return (
    <RouteErrorBoundary homeHref={homeHref} homeLabel={homeLabel}>
      <Suspense fallback={fallback}>{children}</Suspense>
    </RouteErrorBoundary>
  );
}
